import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import LoanList from '@src/components/LoanList/LoanList'
import { useTranslation } from 'react-i18next'

const LoanListPage = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader title={t('loan.title')} breadcrumbs={{ current: t('loan.title') }} />
      <PageContainer>
        <LoanList />
      </PageContainer>
    </>
  )
}

export default LoanListPage
